import { Box, Button, Checkbox, Image, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import "../../molecules/optionLayouts/Mcq.css?__remix_sideEffect__";
import { useRoot } from "../../../context/RootContext";

import { renderContent } from "../../../utils/TutorConstants";
import {
  extractGivenAnswers,
  hasLongString,
  isNotEmptyOrNull } from
"../../../utils/common-utils";
import useStateRef from "react-usestateref";
import { taskTypes } from "../../../utils/LearningPathUtils";
import { getPresentationModeBasedOnTask } from "../../../utils/presentationModes";
import { useTutor } from "../../../context/AiTutorContext";
import ImageModal from "../../atoms/ImageModal";
export const Mcq = (props) => {
  const { isStandaloneWithSubjectMapping, isStandalone, isReviewScreen } =
  useRoot();
  const [selectedValue, setSelectedValue] = useState([]);
  const [answerSubmitted, setAnswerSubmitted] = useState(props?.isDisabled);
  const { selectedIndex } = useRoot();
  const [isOpen, setIsOpen] = useState(false);

  const { isFactual } = useTutor();

  const [presentationMode, setPresentationMode] = useState(
    getPresentationModeBasedOnTask(
      props?.currentQuestion?.factual === true ?
      taskTypes.assessment :
      isReviewScreen ?
      taskTypes.reviewMode :
      isFactual ?
      taskTypes.assessment :
      isStandalone || isStandaloneWithSubjectMapping ?
      taskTypes.standalone :
      props.taskType
    )
  );

  //missed item
  const [optionsData, setOptionsData] = useState(props.options);

  const [imageIndex, setImageIndex] = useState();
  const [onAnswerSubmitted, setOnAnswerSubmitted, onAnswerSubmittedRef] =
  useStateRef(props.onAnswerSubmitted ? props.onAnswerSubmitted : false);

  useEffect(() => {
    if (isNotEmptyOrNull(props.userAnswer)) {
      setSelectedValue(extractGivenAnswers(props.userAnswer));
      setOnAnswerSubmitted(true);
    }
  }, []);

  useEffect(() => {
    if (props.onAnswerSubmitted) {
      setOnAnswerSubmitted(props.onAnswerSubmitted);
    }
  }, [props.onAnswerSubmitted]);

  const getAnswerStyle = (
  item,
  selectedValue,
  answerSubmitted,
  imagesList,
  currentQuestion) =>
  {
    if (!answerSubmitted) {
      if (selectedValue.includes(item)) {
        return imagesList?.length > 0 ?
        "inner-container-selected" :
        "inner-container-selected-noimage";
      } else {
        return imagesList?.length > 0 ?
        "inner-container" :
        "inner-container-noimage";
      }
    } else {
      if (props.answer.includes(item)) {
        if (isReviewScreen) {
          return imagesList?.length > 0 ?
          "inner-container-correct" :
          "inner-container-correct-noimage";
        } else if (
        presentationMode.DisplayCorrectAnswerInstantly ||
        presentationMode.DisplayCorrectAnswerAfterNextClick &&
        currentQuestion?.showGreen)
        {
          return imagesList?.length > 0 ?
          "inner-container-correct" :
          "inner-container-correct-noimage";
        } else {
          if (selectedValue.includes(item)) {
            return props.taskType === taskTypes.assessment || isFactual ?
            imagesList?.length > 0 ?
            "inner-container" :
            "inner-container-noimage" :
            imagesList?.length > 0 ?
            "inner-container-selected" :
            "inner-container-selected-noimage";
          } else {
            return imagesList?.length > 0 ?
            "inner-container" :
            "inner-container-noimage";
          }
        }
      } else if (selectedValue.includes(item)) {
        if (isReviewScreen) {
          return imagesList?.length > 0 ?
          "inner-container-wrong" :
          "inner-container-wrong-noimage";
        } else if (
        presentationMode.DisplayWrongAnswerInstantly ||
        presentationMode.DisplayWrongAnswerAfterNextClick &&
        currentQuestion.showRed)
        {
          return imagesList?.length > 0 ?
          "inner-container-wrong" :
          "inner-container-wrong-noimage";
        } else {
          return props.taskType === taskTypes.assessment || isFactual ?
          imagesList?.length > 0 ?
          "inner-container" :
          "inner-container-noimage" :
          imagesList?.length > 0 ?
          "inner-container-selected" :
          "inner-container-selected-noimage";
        }
      } else {
        return imagesList?.length > 0 ?
        "inner-container" :
        "inner-container-noimage";
      }
    }
  };

  const handleCheckBoxChange = (event) => {
    const itemName = event.target.name;
    const isChecked = event.target.checked;
    const updatedSelectedValue = isChecked ?
    [...selectedValue, itemName] :
    selectedValue.filter((item) => item !== itemName);

    setSelectedValue(updatedSelectedValue);

    props.handleAnswerChange({
      selectedItem: updatedSelectedValue
    });
  };

  const openImage = (index) => {
    setImageIndex(index);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    props.handleAnswerChange({ selectedItem: selectedValue });
  }, [onAnswerSubmittedRef.current]);

  return (
    <div
      id="mcq-wrapper"
      style={props?.isDontAllow ? { pointerEvents: "none" } : {}}>

      <div
        id="mcq-options-container"
        className={
        hasLongString(optionsData) ?
        "outer-container-column" :
        "outer-container"
        }>

        {optionsData.map((item, index) =>
        <div
          id={`mcq-option-${index}`}>

            {/* <Text as="b" fontSize="md">
             {String.fromCharCode(65 + index)}
            </Text> */}
            <Box
            id={`mcq-option-box-${index}`}
            readOnly={onAnswerSubmittedRef.current}
            className={getAnswerStyle(
              item,
              selectedValue,
              onAnswerSubmittedRef.current,
              props?.option_image_details,
              props?.currentQuestion
            )}
            variant={"outlined"}>

              <Checkbox
              data-testid={`mcq-checkbox-${index}`}
              readOnly={onAnswerSubmittedRef.current}
              colorScheme="white"
              iconColor={"white"}
              borderColor={selectedValue.includes(item) ? "white" : "#786AC5"}
              textColor={
              // selectedValue.includes(item) &&
              // props.taskType !== taskTypes.assessment

              props.taskType === taskTypes.assessment || isFactual ?
              !onAnswerSubmittedRef.current ?
              selectedValue.includes(item) ?
              "#ffffff" :
              "#130159" :
              (selectedValue.includes(item) ||
              props.answer.includes(item)) &&
              isReviewScreen ?
              "#ffffff" :
              "#130159" :
              selectedValue.includes(item) ||
              props.answer.includes(item) &&
              onAnswerSubmittedRef.current &&
              presentationMode.DisplayCorrectAnswerAfterNextClick &&
              props?.currentQuestion?.showGreen ?
              "#ffffff" :
              "#130159"
              }
              onChange={!onAnswerSubmittedRef.current && handleCheckBoxChange}
              name={item}>

                {renderContent(props?.modifiedOptions?.[index])}
              </Checkbox>
              {props.option_image_details?.length > 0 &&
            <Image
              id={`mcq-option-image-${index}`}
              className="mcq-image"
              onClick={() => {
                openImage(index);
              }}
              src={props.option_image_details?.[index]?.url}
              alt={`Image ${index}`} />

            }
            </Box>
          </div>
        )}
      </div>
      {isOpen &&
      <div
        id="mcq-image-modal-wrapper"
        style={{ background: "blue" }}>

          <ImageModal
          data-testid="mcq-image-modal"
          key={Math.random()}
          isOpen={isOpen}
          handleClose={handleClose}
          url={props.option_image_details?.[imageIndex]?.url} />

        </div>
      }
    </div>);

};